import { render, staticRenderFns } from "./ProblemComplaint.vue?vue&type=template&id=0a84899a&scoped=true&"
import script from "./ProblemComplaint.vue?vue&type=script&lang=js&"
export * from "./ProblemComplaint.vue?vue&type=script&lang=js&"
import style0 from "./ProblemComplaint.vue?vue&type=style&index=0&id=0a84899a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84899a",
  null
  
)

export default component.exports